export default __webpack_public_path__ + "671977a643066fb0b07293ecdefcb227.svg";